/* Theme-local reassurance. Prices, calendar validation and checkout belong to the apps. */
(() => {
  'use strict';
  const checkoutSelector = '.kaching-cart__footer > .kaching-cart__checkout-button';
  const photoSelector = '#kaching-cart .kaching-cart-item, #kaching-cart .kaching-product-upsell-item';
  let originals = {};
  try { originals = JSON.parse(document.getElementById('j-cart-original-images')?.textContent || '{}'); } catch (_) { /* Keep app images if map unavailable. */ }
  const deliveryNoteSelector = '#kaching-cart .ot-dingdoong-header-additional-message';
  const campaignProducts = new Set(['artgerechtes-bio-fleisch-willkommens-paket', 'willkommenspaket-iii-connoisseur-paket']);
  const campaignEntry = /^\/(pages\/(willkommens-angebot|willkommens-checkout)|products\/(artgerechtes-bio-fleisch-willkommens-paket|willkommenspaket-iii-connoisseur-paket))\/?$/.test(location.pathname);
  function streamline() {
    const cart = document.querySelector('#kaching-cart');
    if (!cart) return;
    const handles = [...cart.querySelectorAll('.kaching-cart-item')].map(item => item.dataset.productHandle);
    const welcome = handles.some(handle => ['willkommenspaket-i-probier-paket', 'artgerechtes-bio-fleisch-willkommens-paket', 'willkommenspaket-iii-connoisseur-paket'].includes(handle));
    // Metzgerpaket ships free, one-off and subscription (Lars, 29.10.2026); its FREIVERSAND SKU frees the whole order at checkout.
    const butcher = handles.some(handle => ['all-rounder-box', 'hack-basics-metzgerpaket'].includes(handle));
    const included = welcome || butcher;
    cart.classList.toggle('j-cart-shipping-included', included);
    const bar = cart.querySelector('.kaching-cart__tiered-promotions-bar');
    let note = cart.querySelector('.j-cart-shipping-note');
    if (bar && included && !note) {
      note = document.createElement('p');
      note.className = 'j-cart-shipping-note';
      bar.insertAdjacentElement('afterend', note);
    }
    const noteText = butcher
      ? 'Dein Metzgerpaket enthält den Standardversand in Deutschland, für die ganze Bestellung.'
      : 'Dein Willkommenspaket enthält den Standardversand in Deutschland. Donnerstag Express: 10 € Aufschlag.';
    if (note && note.textContent !== noteText) note.textContent = noteText;
    const groups = [
      ['rib-eye', 'rinderfilet', 'onglet-vom-rind', 'flanksteak-vom-rind', 'ochsenfetzen', 'roastbeef'],
      ['hahnchenbrust', 'putenschnitzel', 'hahnchenschenkel', 'hahnchenflugerl'],
      ['halsgrat', 'schweinelende', 'schweineschnitzel', 'schweinebauch'],
      ['rinderhackfleisch', 'hackfleisch-gemischt', 'schweinehackfleisch']
    ];
    const group = groups.find(items => handles.some(handle => items.includes(handle)));
    const offers = [...cart.querySelectorAll('.kaching-product-upsell-item')].filter(item => {
      const href = item.querySelector('a[href*="/products/"]')?.getAttribute('href');
      const handle = item.dataset.productHandle || href?.match(/\/products\/([^/?#]+)/)?.[1];
      if (!campaignEntry && campaignProducts.has(handle)) {
        (item.closest('.kaching-product-upsell-item-container') || item).remove();
        return false;
      }
      return true;
    });
    const eligible = offers.filter(item => !handles.includes(item.dataset.productHandle));
    const ranked = eligible.map((item,index) => ({item,index,score:group?.includes(item.dataset.productHandle) ? 1 : 0})).sort((a,b) => b.score-a.score || a.index-b.index);
    const selected = new Set(ranked.slice(0,2).map(entry=>entry.item));
    offers.forEach(item => {
      const container = item.closest('.kaching-product-upsell-item-container') || item;
      container.classList.toggle('j-cart-offer-hidden', !selected.has(item));
      item.closest('.kaching-cart__carousel')?.classList.add('j-cart-two-offers');
    });
  }
  function enhance() {
    streamline();
    document.querySelectorAll(photoSelector).forEach((item) => {
      const link = item.querySelector('a[href*="/products/"]');
      const match = link?.getAttribute('href')?.match(/\/products\/([^/?#]+)/);
      const handle = item.dataset.productHandle || match?.[1];
      const photo = item.querySelector('img');
      if (!photo || !originals[handle]) return;
      if (photo.getAttribute('src') !== originals[handle]) photo.setAttribute('src', originals[handle]);
      if (photo.hasAttribute('srcset')) photo.removeAttribute('srcset');
      if (photo.dataset.jOriginal !== handle) photo.dataset.jOriginal = handle;
    });
    document.querySelectorAll(deliveryNoteSelector).forEach((note) => {
      if (note.textContent.trim() === 'Donnerstag 24h Premium Versand Aufschlag') {
        note.textContent = 'Donnerstags: 24h Express, 10 € Aufschlag.';
      }
    });
    document.querySelectorAll(checkoutSelector).forEach((button) => {
      const footer = button.parentElement;
      if (footer.querySelector('[data-premium-cart-trust]')) return;
      const note = document.createElement('div');
      note.className = 'r-premium-cart-trust';
      note.dataset.premiumCartTrust = '';
      const title = document.createElement('strong');
      title.textContent = 'Dein Fleisch kommt vakuumiert und gekühlt.';
      const links = document.createElement('p');
      const shipping = document.createElement('a');
      shipping.href = '/pages/premium-versand';
      shipping.textContent = 'Versandkosten & Lieferung';
      const help = document.createElement('a');
      help.href = '/pages/faqs#faq-geld-zurueck';
      help.textContent = 'Deine Zufriedenheit zählt';
      links.append(shipping, help);
      note.append(title, links);
      button.insertAdjacentElement('afterend', note);
    });
  }
  let queued = false;
  const observer = new MutationObserver((records) => {
    const newPhoto = records.some(record => record.type === 'attributes' && record.target.matches('#kaching-cart img'));
    const newCheckout = records.some(record => [...record.addedNodes, ...record.removedNodes].some(node =>
      node.nodeType === 1 && (node.matches('#kaching-cart, ' + checkoutSelector + ', ' + deliveryNoteSelector + ', ' + photoSelector) || node.querySelector(checkoutSelector + ', ' + deliveryNoteSelector + ', ' + photoSelector))
    ));
    if ((!newCheckout && !newPhoto) || queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; enhance(); });
  });
  enhance();
  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'srcset'] });
})();
